module.exports = __webpack_public_path__ + "static/media/globe-americas.e6b42025.svg";